define([
  "marionette",
  "jquery",
  "messaging/messenger",
  "configuration/properties",
  "./template/taskWizardDenialNextStepsPageTemplate.html",
], function (Marionette, $, Messenger, Properties, TaskWizardDenialNextStepsPageTemplate) {
  "use strict";

  var TaskWizardDenialNextStepsPageView = {};

  TaskWizardDenialNextStepsPageView.denialNextStepsPageView = Marionette.Layout.extend({
    className: "form-horizontal",
    template: TaskWizardDenialNextStepsPageTemplate,
    regions: {
      taskDenialNextSteps: ".task-denial-next-steps",
    },
    ui: {
      localeDenialNextStep: ".locale-steps-denial-next-step",
      taskDescription: ".task-description",
      taskDescriptionError: ".task-description-error",
      taskName: ".task-name",
      taskNameError: ".task-name-error",
    },
    clearErrors: function () {
      this.ui.taskNameError.html("");
      this.ui.taskDescriptionError.html("");
    },
    descriptionError: function (message) {
      this.ui.taskDescriptionError
        .html('<h5 class="error-message">' + message + "</h5>")
        .hide()
        .fadeIn();
    },
    nameError: function (message) {
      this.ui.taskNameError
        .html('<h5 class="error-message">' + message + "</h5>")
        .hide()
        .fadeIn();
    },
    getLocaleDenialNextStep: function () {
      var value = this.ui.localeDenialNextStep.val();
      return +value;
    },
    getTaskDescription: function () {
      var value = this.ui.taskDescription.val();
      var trimmedValue = value.trim();
      if (value != trimmedValue) {
        this.ui.taskDescription.val(trimmedValue);
      }
      return trimmedValue;
    },
    getTaskName: function () {
      var value = this.ui.taskName.val();
      var trimmedValue = value.trim();
      if (value != trimmedValue) {
        this.ui.taskName.val(trimmedValue);
      }
      return trimmedValue;
    },
  });

  return TaskWizardDenialNextStepsPageView;
});
